/** Helpers for generated Hey API React Query keys (`queryKey[0]._id`). */

export function queryKeyOperationId(
  queryKey: readonly unknown[],
): string | null {
  const first = queryKey[0];
  if (
    first &&
    typeof first === "object" &&
    "_id" in first &&
    typeof (first as { _id: unknown })._id === "string"
  ) {
    return (first as { _id: string })._id;
  }
  return null;
}

export const LICENSE_LIST_QUERY_IDS = [
  "getNonRegistrantLicenses",
  "getRegistrantLicenses",
] as const;

export const LICENSE_STATS_QUERY_IDS = [
  "getNonRegistrantLicenseStats",
  "getRegistrantLicenseStats",
] as const;

export const LICENSE_MAP_PINS_QUERY_IDS = [
  "getNonRegistrantLicenseMapPins",
  "getRegistrantLicenseMapPins",
] as const;

export const LICENSE_FILTER_VALUES_QUERY_IDS = [
  "getNonRegistrantLicenseFilterValues",
  "getRegistrantLicenseFilterValues",
] as const;

export const OMT_LICENSE_LIST_QUERY_KEY = "omt-ams-licenses";
export const OMT_LICENSE_STATS_QUERY_KEY = "omt-ams-stats";
export const OMT_LICENSE_MAP_QUERY_KEY = "omt-ams-map-pins";
export const OMT_LICENSE_DETAIL_QUERY_KEYS = [
  "omt-ams-license-comments",
  "omt-ams-license-payments",
] as const;

export const LICENSE_DETAIL_QUERY_IDS = [
  "getLicenseDetails",
  "getNonRegistrantLicenseComments",
  "getLicenseComments",
  "getNonRegistrantLicensePayments",
  "getLicensePayments",
  // Period compliance and payable periods are derived from fees and the
  // approval cutoff, so an approval or payment edit changes them too.
  "getFeesForRenewal",
  "getManualPaymentAvailablePeriods",
] as const;
